import Highcharts from "highcharts";
import "highcharts/highcharts-more";

// Add custom attributes to the AST to make it possible to hook some stimulus
// controllers into the Highcharts elements.
Highcharts.AST.allowedAttributes.push(
  "data-controller",
  "data-utils--website--employers--tooltip",
  "data-utils--website--employers--tooltip-target",
  "data-utils--website--employers--tooltip-append-to-value",
);

export default Highcharts;
